<template>
    <!-- 전체 콘텐츠 영역 -->
    <div class="main-contents">
        <div class="mem_container">
            <!-- <div class="mem_contents_header myp">
                <div class="title-txt"><nbsp n="2"/>{{$store.state.userInfo.mberNm}}님 반갑습니다.<br/>
                    <p class="myp" v-if="notiState">새로운 요청이 있습니다.</p>
                </div>
            </div> -->
            
            <div class="myp-banner" v-if="notiState == '01'">
                <div>이력서를 등록해 주세요.</div>
                <div class="shortcut" @click="$router.push({name: 'PRF101M01'})">이력서 등록하러 가기 <span>&#9654;</span></div>
            </div>
            
            <div class="mem_info_contents">
                <tec-info ref="info" v-model="info" :tecMberSeq="$store.state.userInfo.mberSeq"/>
                <tec-resume-view ref="tecResumeView" v-model="resume"  :tecMberSeq="$store.state.userInfo.mberSeq"/>
            </div>
        </div>
    </div>
</template>

<script>
import tecInfo from "@/components/highpro/TecInfo.vue";
import tecResumeView from "@/components/highpro/TecResumeView.vue";

export default {

        components: { tecInfo, tecResumeView },
        data() {
            return {
                notiState : '',
                state : {},
                info: { },
                resume: { },
            };
        }, 
        

        // beforeMount(){
        //     this.$.httpPost('/api/mem/prf/getResumeState')
        //             .then((res) => {
        //                 if(res.data){
        //                     this.state = res.data;
        //                     if(this.state.resmYn == 'N'){
        //                         this.notiState = '01';
        //                     }
        //                 }
        //             }) 
        // },

        mounted() {
            this.$.httpPost('/api/mem/prf/getResumeState')
                .then((res) => {
                    if(res.data){
                        this.state = res.data;
                        if(this.state.resmYn == 'N'){
                            this.notiState = '01';
                        }
                    }
                });
            
            // setTimeout(() => {
            //     if(this.$route.query.userDstic == '') {
            //         this.recmmRegiPup();
            //     }
            // }, 100);

            // console.log(this.$router.history);
        },

        // beforeDestroy() {
        //     window.removeEventListener("beforeunload", event);
        // },
        
        methods: {
            // recmmRegiPup() {
			// this.$.popup('/mem/MEM001P05')
			// 	.then(res => {
			// 		if(res) {
			// 			this.regiRecmmder(res.recmmderHpNo);
			// 		}else {
            //             history.replaceState({}, null, location.pathname);
            //         }
			// 	});
            // },
            // regiRecmmder(recmmderHpNo) {
            //     this.$.httpPost('/api/mem/updateMberInfo', {mberInfo: {recmmderHpNo, mberSeq: this.$store.state.userInfo.mberSeq}})
            //         .then(res => {
            //             if(res.data.resultCode == "000"){
            //                 alert("추천인 등록이 완료되었습니다.");
            //                 history.replaceState({}, null, location.pathname);
            //             }else {
            //                 alert(res.data.message);
            //             }
            //         })
            //         .catch(err => {
            //             alert(err.response.data.error_description);
            //         });
            // },
        },
    };
</script>